import { useState } from "react";
import { api, apiError } from "@/lib/api";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";
import { toast } from "sonner";

export const DeleteProjectDialog = ({ target, onClose, onDeleted }) => {
  const [busy, setBusy] = useState(false);

  const confirm = async () => {
    setBusy(true);
    try {
      await api.delete(`/projects/${target.id}`);
      toast.success(`Moved "${target.name}" to Trash`);
      onClose();
      onDeleted();
    } catch (e) { toast.error(apiError(e)); } finally { setBusy(false); }
  };

  return (
    <AlertDialog open={!!target} onOpenChange={(o) => !o && onClose()}>
      <AlertDialogContent data-testid="delete-confirm-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle>Move “{target?.name}” to Trash?</AlertDialogTitle>
          <AlertDialogDescription>
            The project moves to the Trash, where you can restore it. Items in the Trash are
            permanently deleted after 24 hours (or sooner if you empty the Trash).
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="delete-cancel">Cancel</AlertDialogCancel>
          <AlertDialogAction onClick={confirm} disabled={busy}
            className="bg-destructive text-destructive-foreground hover:bg-destructive/90" data-testid="delete-confirm">
            {busy ? "Moving…" : "Move to Trash"}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export const BulkDeleteDialog = ({ open, onOpenChange, ids, onDeleted }) => {
  const [busy, setBusy] = useState(false);

  const confirm = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/projects/bulk-delete", { ids });
      toast.success(`Moved ${data.deleted} project(s) to Trash`);
      onOpenChange(false);
      onDeleted();
    } catch (e) { toast.error(apiError(e)); } finally { setBusy(false); }
  };

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent data-testid="projects-bulk-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle>Move {ids.length} project{ids.length === 1 ? "" : "s"} to Trash?</AlertDialogTitle>
          <AlertDialogDescription>The selected projects move to the Trash, where you can restore them. Items in the Trash are permanently deleted after 24 hours (or sooner if you empty the Trash).</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="projects-bulk-cancel">Cancel</AlertDialogCancel>
          <AlertDialogAction onClick={confirm} disabled={busy} className="bg-destructive text-destructive-foreground hover:bg-destructive/90" data-testid="projects-bulk-confirm">{busy ? "Moving…" : "Move to Trash"}</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
